<template>
  <div>
    <div>
      <el-button :size="size" type="primary" @click.native="clickIndexLeft">{{$t('action.cancel')}}</el-button>
    </div>
    <div class="page-scan">
      <!-- 扫码区域 -->
      <video ref="video" id="video" class="scan-video" autoplay></video>
      <!-- 提示语 -->
      <div v-show="tipShow" class="scan-tip"> {{tipMsg}} </div>
    </div>
  </div>
</template>

<script>
import { BrowserMultiFormatReader } from '@zxing/library';

export default {
  name: 'ScanCodePage',
  data() {
    return {
      size:'small',
      editDialogVisible: false, // 新增编辑界面是否显示
      mainProcessName: null,
      subProcessName: null,
      whId: null,
      clientCode: null,
      localeId: null,
      loadingShow: false,
      codeReader: null,
      scanText: '',
      vin: null,
      tipMsg: '正在尝试识别....',
      tipShow: false
    }
  },
  activated: function () {
    this.scanText=null
    this.editDialogVisible=this.$route.query.editDialogVisible
    this.mainProcessName=this.$route.query.mainProcessName
    this.subProcessName=this.$route.query.subProcessName
    this.whId=this.$route.query.whId
    this.clientCode=this.$route.query.clientCode
    this.localeId=this.$route.query.localeId
    this.openScan();
  },
  methods: {
    async openScan() {
      this.codeReader = await new BrowserMultiFormatReader();
      this.codeReader.getVideoInputDevices().then((videoInputDevices) => {
        this.tipShow = true;
        this.tipMsg = '正在调用摄像头...';
        console.log('videoInputDevices', videoInputDevices);
        // 默认获取第一个摄像头设备id
        let firstDeviceId = videoInputDevices[0].deviceId;
        // 获取第一个摄像头设备的名称
        const videoInputDeviceslablestr = JSON.stringify(videoInputDevices[0].label);
        if (videoInputDevices.length > 1) {
          // 判断是否后置摄像头
          if (videoInputDeviceslablestr.indexOf('back') > -1) {
            firstDeviceId = videoInputDevices[0].deviceId;
          } else {
            firstDeviceId = videoInputDevices[1].deviceId;
          }
        }
        this.decodeFromInputVideoFunc(firstDeviceId);
      }).catch(err => {
        this.tipShow = false;
        console.error(err);
      });
    },
    decodeFromInputVideoFunc(firstDeviceId) {
      this.codeReader.reset(); // 重置
      this.scanText = '';
      this.codeReader.decodeFromInputVideoDeviceContinuously(firstDeviceId, 'video', (result, err) => {
        this.tipMsg = '正在尝试识别...';
        this.scanText = '';
        if (result) {
          console.log('扫描结果', result);
          this.scanText = result.text;
          if (this.scanText) {
            this.tipShow = false;
            // 这部分接下去的代码根据需要，读者自行编写了
            this.clickIndexLeft();
          }
        }
        if (err && !(err)) {
          this.tipMsg = '识别失败';
          setTimeout(() => {
            this.tipShow = false;
          }, 2000)
        }
      });
    },
    clickIndexLeft(){  // 返回上一页
      let thisVideo = document.getElementById("video");
      thisVideo.srcObject.getTracks()[0].stop()
      this.codeReader.reset();
      this.$destroy();
      this.$router.push({
        path: '/Core/RfDialog',
        query:{
          editDialogVisible: this.editDialogVisible,
          mainProcessName:this.mainProcessName,
          subProcessName:this.subProcessName,
          whId:this.whId,
          clientCode:this.clientCode,
          localeId:this.localeId,
          scanText : this.scanText
        }
      })
      // this.$route.params.editDialogVisible = this.editDialogVisible;
      // this.$route.params.scanText = this.scanText;
      // this.$router.back();
    }
  }
}
</script>

<style lang="scss">
.scan-index-bar{
  background-image: linear-gradient( -45deg, #42a5ff ,#59cfff);
}
.van-nav-bar__title{
  color: #fff !important;
}
.scan-video{
  height: 80vh;
}
.scan-tip{
  width: 100vw;
  text-align: center;
  margin-bottom: 10vh;
  color: white;
  font-size: 5vw;
}
.page-scan{
  overflow-y: hidden;
  background-color: #363636;
}
</style>



// WEBPACK FOOTER //
// src/views/Core/ScanCodePage.vue